import { computed, unref, type MaybeRef } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { session } from '@/composables/useSession'
import { getAssignmentsIncompleteCount } from '@/modules/tasks/api'
import { tasksAssignmentKeys } from './keys'

interface UseTasksIncompleteQueryOptions {
  enabled?: MaybeRef<boolean>
}

export const useTasksIncompleteQuery = (options: UseTasksIncompleteQueryOptions = {}) => {
  const workspaceId = computed(() => session.workspace?.id ?? null)
  const enabled = computed(() => workspaceId.value !== null && unref(options.enabled ?? true))

  return useQuery({
    queryKey: computed(() => tasksAssignmentKeys.incompleteCount(workspaceId.value)),
    queryFn: () => getAssignmentsIncompleteCount(),
    enabled,
    staleTime: Infinity,
    retry: false,
  })
}
